import { LitElement, html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './app-notallowed-styles.css?inline';

import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';

@customElement('app-notallowed')
export class AppNotAllowed extends LitElement {
  static styles = [unsafeCSS(styles)];

  handleBack() {
    window.history.length > 1
      ? window.history.back()
      : window.location.assign('/');
  }

  render() {
    return html`
      <div class="notallowed-container">
        <sl-icon name="shield-lock-fill" class="icon"></sl-icon>
        <h2>Access Denied</h2>
        <sl-alert variant="danger" open>
          <strong>Sorry, you do not have permission to view this page.</strong>
          <div>
            The link you tried to access requires additional permissions or
            roles. If you believe this is an error, please contact your
            administrator.
          </div>
        </sl-alert>
        <sl-button variant="primary" @click=${this.handleBack}
          >Go Back</sl-button
        >
      </div>
    `;
  }
}
